import { useContext, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Drawer } from "@mui/material";
import DeviceCard from "./DeviceCard";
import { UIReducerActionType } from "../reducers/uiReducer";
import { DeviceContext } from "../contexts/DeviceContext";
import { UIContext } from "../contexts/UIContext";
import "../styles/DeviceList.css";

const DeviceList = () => {
  const [open, setOpen] = useState(true);
  const { device } = useContext(DeviceContext);
  const { uiDispatch } = useContext(UIContext);
  const activeDevice = device.filter(dev => dev.isActive === true);

  const onListClick = () => {
    setOpen(false);
  };

  const onMenuClick = () => {
    setOpen(true);
  };

  const onDeviceDetailClick = () => {
    uiDispatch({ type: UIReducerActionType.SHOW_DETAIL, payload: true });
  };

  const deviceMenu = (
    <div className="devicelist-menu devicelist-mobile">
      <div className="devicelist-menu-content devicelist-menu-icon" onClick={ onMenuClick }/>
      <div className="devicelist-menu-content devicelist-menu-deviceinfo">
        <div className="devicelist-menu-content devicelist-menu-devicename">{ activeDevice.length > 0 ? activeDevice[0].displayName : null }</div>
        <div className="devicelist-menu-content devicelist-menu-devicedetail" onClick={ onDeviceDetailClick }>
          <FormattedMessage id="device_detail" />
        </div>
      </div>
    </div>
  );

  const deviceListMobile = (
    <Drawer className="devicelist-mobile" anchor="left" open={ open } onClick={ onListClick }>
      <div className="devicelist-list-outer">
        <ul className="devicelist-list" >
          { device.map(dev => <DeviceCard key={ dev.guid } device={ dev } /> ) }
        </ul>
      </div>
    </Drawer>
  );

  const deviceListDesktop = (
    <div className="devicelist-list-outer devicelist-desktop">
      <ul className="devicelist-list" >
        { device.map(dev => <DeviceCard key={ dev.guid } device={ dev } /> ) }
      </ul>
    </div>
  );

  const enptyList = (
    <div>
      {/* <p>沒有手機就沒有Lost的問題了ㄛ<br/><br/> (σ′▽‵)′▽‵)σ. σ ﾟ∀ ﾟ) ﾟ∀ﾟ)σ</p> */}
    </div>
  );

  return (
    device.length > 0 ? (
      <>
        { deviceMenu }
        { deviceListMobile }
        { deviceListDesktop }
      </> )
    : 
      enptyList
  );
};

export default DeviceList;
